import { i18next } from '@ui/i18n';

export const decimalsValidator = (value: string, maxDecimalsAllowed = 18) => {
  if (
    value &&
    !new RegExp(`^[0-9]+\\.?[0-9]{0,${maxDecimalsAllowed}}$`).test(value)
  ) {
    if (new RegExp(`\\.?[0-9]{${maxDecimalsAllowed + 1},}$`).test(value)) {
      return i18next.t('maximum {decimal} decimal places allowed', {
        decimal: maxDecimalsAllowed,
      });
    } else {
      return i18next.t('invalid format');
    }
  }
};

export const balanceValidator = (
  value: string,
  maxAmount: number | undefined,
) => {
  if (maxAmount !== undefined && parseFloat(value) > maxAmount) {
    return i18next.t('Insufficient Balance');
  }
};
